export const resolveTableType = (tableType) => {
  if (!tableType) return "AC";
  if (typeof tableType === "string") return tableType.trim() || "AC";
  if (Array.isArray(tableType)) {
    if (tableType.length === 0) return "AC";
    const first = tableType[0];
    if (typeof first === "string") return first.trim() || "AC";
    if (first && typeof first === "object") {
      return first.tableType || first.name || first.type || "AC";
    }
  }
  if (typeof tableType === "object") {
    return tableType.tableType || tableType.name || tableType.type || "AC";
  }
  return String(tableType) || "AC";
};

const price = (tableType, data) => {
  if (!data) return 0;

  let toppingPrice = 0;
  if (Array.isArray(data.activeTopping)) {
    data.activeTopping.forEach((topping) => {
      toppingPrice += Number(topping?.itemPrice) || 0;
    });
  }

  const resolvedTableType = resolveTableType(tableType);

  // Price field mapping
  const priceFieldMap = {
    AC: "priceForAC",
    "Non AC": "priceForNonAC",
    Garden: "priceForGarden",
    "Banquet Hall": "priceForBanquetHall",
    Hut: "priceForHut",
    Online: "priceForOnline",
    "Room Service": "priceForRoomService",
    HD: "priceForHD",
    Parcel: "priceForParcel",
  };

  const priceField = priceFieldMap[resolvedTableType];
  const rawPrice = priceField && data[priceField] !== undefined && data[priceField] !== null && data[priceField] !== ""
    ? data[priceField]
    : data.itemPrice;
  const basePrice = Number(rawPrice) || 0;

  return basePrice + toppingPrice;
};

export default price;